import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/AppActions';
import { URL } from '../../variables';
import DefaultButton from '../ReusableComponents/DefaultButton';
import { BsFillEyeFill } from "react-icons/bs";
import { RiArrowGoBackLine } from 'react-icons/ri';
import { Button } from "react-bootstrap";
import { FaListAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { MdModeEdit, MdDelete, MdEdit } from 'react-icons/md';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SweetAlert from 'react-bootstrap-sweetalert';
import Skeleton from '@material-ui/lab/Skeleton';
import TabPanel from '../ReusableComponents/TabPanel';
import ModuleTabChooser from '../ReusableComponents/ModuleTabChooser';
import TextReadMore from '../ReusableComponents/TextReadMore';
import TableEmptyState from '../ReusableComponents/TableEmptyState';

class ShowTreinamento extends Component {static contextType = PreferencesContext;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      nome: '',
      descricao: '',
      showDeleteConfirmation: false,
      errorMsg: '',
      moduleToDelete: null,
      modulos: [],
      loading: true,
      activeTab: -1
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    let tab = new URLSearchParams(this.props.location.search).get('tab');
    if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });else
    if (tab === null) this.setState({ activeTab: -1 });
    this.getModule(id);
    localStorage.setItem('idContent', id);
  }

  async getModule(id) {
    this.setState({ loading: true });
    try {
      const response = await fetch(`${URL}api/treinamento/get_training/${id}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Authorization': `Bearer ${this.props.token}`
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar o módulo');
      }

      const data = await response.json();
      const { nome, descricao, modulos } = data.data;

      this.setState({
        nome: nome,
        descricao: descricao,
        modulos: modulos,
        loading: false
      });

      if (data.errors) {
        let errors = Object.values(data.errors);
        let errorMsg = errors.join('\n');
        this.setState({ errorMsg: errorMsg });
      }
    } catch (error) {
      console.error(error.message || 'Erro ao buscar o módulo');
      this.setState({ errorMsg: error.message || 'Erro ao buscar o módulo', loading: false });
    }
  }

  async saveOrder(modulos) {
    const { id } = this.props.match.params;
    try {
      const response = await fetch(`${URL}api/treinamento/edit_training/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.token}`
        },
        body: JSON.stringify({
          nome: this.state.nome,
          descricao: this.state.descricao,
          modulo_ids: modulos.map((modulo) => modulo.id)
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao salvar a nova ordem');
      }

      const data = await response.json();
      if (data.errors) {
        let errors = Object.values(data.errors);
        let errorMsg = errors.join('\n');
        this.setState({ errorMsg: errorMsg });
      }
    } catch (error) {
      console.error(error.message || 'Erro ao salvar a nova ordem');
      this.setState({ errorMsg: error.message || 'Erro ao salvar a nova ordem' });
    }
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const modulos = [...this.state.modulos];
    const [reorderedItem] = modulos.splice(result.source.index, 1);
    modulos.splice(result.destination.index, 0, reorderedItem);

    this.setState({ modulos: modulos }, () => {
      this.saveOrder(modulos);
    });
  };

  handleDeleteModule = async (modulo) => {
    const { id } = this.props.match.params;

    try {
      const response = await fetch(`${URL}api/treinamento/remove_module_from_training/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.token}`
        },
        body: JSON.stringify({
          modulo_id: modulo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao desvincular conteúdo');
      }

      const data = await response.json();
      if (data.errors) {
        let errors = Object.values(data.errors);
        let errorMsg = errors.join('\n');
        this.setState({ errorMsg: errorMsg });
      } else {
        this.setState((prevState) => ({
          modulos: prevState.modulos.filter((item) => item.id !== modulo.id),
          showDeleteConfirmation: false
        }));
      }
    } catch (error) {
      console.error(error.message || 'Erro ao desvincular conteúdo');
      this.setState({ errorMsg: error.message || 'Erro ao desvincular conteúdo' });
    } finally {
      this.getModule(id);
    }
  };





  handleDeleteConfirmation(modulo) {
    this.setState({ moduleToDelete: modulo, showDeleteConfirmation: true });
  }

  renderContentSkeleton() {
    return (
      <div>
                <div style={{ float: 'right' }}>
                    <Skeleton variant="text" width={100} height={40} />
                </div>
                <div className="d-flex flex-column">
                    <Skeleton variant="text" width={200} height={40} />
                    <Skeleton variant="text" width={300} height={20} />
                </div>

                <hr />
                <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>
                    <Skeleton variant="text" width={300} height={30} />
                </h4>
                <p style={{ fontSize: '1rem', color: 'black' }}>
                    <Skeleton variant="text" width={400} height={20} />
                </p>
                <div className="d-flex" style={{ justifyContent: 'flex-end' }}>
                    <Skeleton variant="rect" width={150} height={40} style={{ marginRight: '10px' }} />
                    <Skeleton variant="rect" width={150} height={40} />
                </div>

                <br /><br />
                <div className="row">
                    <div className="col-12">
                        <Skeleton variant="rect" width="100%" height={400} />
                    </div>
                </div>
            </div>);

  }

  renderContent() {
    const { nome, descricao, modulos, moduleToDelete, errorMsg, showDeleteConfirmation
    } = this.state;
    const { id } = this.props.match.params;

    return (
      <div>
                <div style={{ float: 'right' }}>
                    <DefaultButton
            bg="secondary"
            text={this.context.t("back")}
            icon={<RiArrowGoBackLine />}
            to={`/treinamentos`} />

                </div>
                <div className="flex jcsb">
                                <h4 className="header">{nome}</h4>

                            </div>
                            <div className="w100 margin-bottom">

                                <TextReadMore title={this.context.t("legacy_descricao")} element="div" limit={1000} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                                    {descricao}
                                </TextReadMore>
                            </div>

                <ModuleTabChooser
          activeTab={this.state.activeTab}
          modules={[
          { id: 0, title: this.context.t("title_modules"), description: this.context.t("legacy_visualize_os_modulos_vinculados_ao_treinamento") }]
          }
          onSelect={(value) => {
            this.setState({ activeTab: value });
            this.props.history.push({ search: `?tab=${value}` });
          }}
          onBack={() => {
            this.setState({ activeTab: -1 });
            this.props.history.push({ search: '' });
          }} />

                <TabPanel value={this.state.activeTab} index={0}>
                <p style={{ fontSize: '1rem', color: 'black' }}>{`${this.context.t("legacy_aqui_sao_listados_todos_os_modulos_vinculados_com_o_treinamento")} `}{nome}</p>
                <div className="d-flex" style={{ justifyContent: 'flex-end' }}>

                    <Link to={'/treinamento/edit/' + id} style={{ textDecoration: "none" }}>
                                                <Button variant="success" className="flex align-center jcc">
                                                    <MdEdit style={{ marginRight: 10 }} />
                                                    <p style={{ margin: 0 }}>{this.context.t("ui_editar_treinamento_modulos_e4254df3")}</p>
                                                </Button>
                                            </Link>
                </div>

                <br />
                <div className="row">
                    <div className="col-12">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="modulos">
                                {(provided) =>
                  <table
                    id="tech-modulos"
                    className="table table-striped"
                    {...provided.droppableProps}
                    ref={provided.innerRef}>

                                        <thead>
                                            <tr>
                                                <th>{this.context.t("label_name")}</th>
                                                <th>{this.context.t("label_actions")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modulos.map((modulo, index) =>
                      <Draggable key={modulo.id.toString()} draggableId={modulo.id.toString()} index={index}>
                                                    {(provided) =>
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}>

                                                            <td>{modulo.name}</td>
                                                            <td>
                                                                <div className="actions-group">
                                                                <Link to={`/modulo/show/${modulo.id}`} onClick={(e) => e.stopPropagation()}>
                                                                    <span className="inline-flex align-center jcc bg-warning icon" style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px" }} title={this.context.t("legacy_gerenciar")}>
                                                                        <BsFillEyeFill size={17} color="white" />
                                                                    </span>
                                                                </Link>

                                                                <span
                              onClick={() => this.setState({ showDeleteConfirmation: true, moduleToDelete: modulo.id })}
                              className="bg-danger icon inline-flex justify-content-center align-items-center"
                              style={{ width: "2em", height: "2em", borderRadius: "7px", cursor: 'pointer' }}
                              title="Deletar treinamento">

                                                                    <MdDelete size={17} color="white" />
                                                                </span>

                                                                </div>
                                                                </td>
                                                        </tr>
                        }
                                                </Draggable>
                      )}
                                            {provided.placeholder}
                                        </tbody>
                                    </table>
                  }
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                {modulos.length === 0 &&
          <div className="row mt-3">
                                            <div className="col-12">
                                                <TableEmptyState title={this.context.t("ui_nenhum_modulo_cadastrado_f4cff322")} icon="📋" />
                                            </div>
                                        </div>
          }
                </TabPanel>

                <SweetAlert
          warning
          title={this.context.t("legacy_atencao")}
          show={showDeleteConfirmation}
          onConfirm={() => {
            this.handleDeleteModule(moduleToDelete);
            this.setState({ showDeleteConfirmation: false, loading_search: true });
          }}
          onCancel={() => this.setState({ showDeleteConfirmation: false })}
          confirmBtnText={this.context.t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={this.context.t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>

                    {errorMsg ? errorMsg : "Ao desvincular este módulo, ele não estará mais disponível no seu treinamento"}
                </SweetAlert>
            </div>);

  }

  render() {
    const { loading } = this.state;

    return (
      <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">
                            {loading ?
              this.renderContentSkeleton() :

              this.renderContent()
              }
                        </div>
                    </div>
                </div>
            </div>);

  }
}

const mapStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token
});

export default connect(mapStateToProps, { logout })(ShowTreinamento);